export default {"src":"/_next/static/media/w_call.567ae529.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};